@if (pagination && pagination.rowCount > 0) {
  <div class="pagination-container">
    <!-- Items per page dropdown -->
    @if (showPageSizeSelector) {
      <div class="page-size-selector">
        <label for="pageSize" translate>Items Per Page</label>
        @if (showPageSizeSelector) {
          <div class="mini-dropdown">
            <button (click)="toggleDropdown()" [disabled]="loading" class="mini-dropdown__btn" id="pageSize">
              {{ pagination.pageSize }}
              <span>
                <app-icon [cssStyle]="{ marginBottom: '' }" color="-var(--deep-gray)" iconName="chevron-down" size="7px" />
              </span>
            </button>
            <div [class.open]="isDropdownOpen" class="mini-dropdown__content">
              @for (size of itemsPerPageOptions; track size) {
                <a (click)="onPageSizeChange(size)">{{ size }}</a>
              }
            </div>
          </div>
        }
      </div>
    }
    <!-- Pagination controls -->
    @if (showPagination) {
      <div class="pagination-controls">
        @if (showFirstLastButtons) {
          <button (click)="changePage(1)" [disabled]="pagination.page === 1 || loading" class="nav-button">
            <app-icon [color]="selectedPageBgColor" [cssStyle]="{ marginBottom: '±' }" iconName="chevron-left" size="14px"></app-icon>
          </button>
        }
        @if (showPreviousNextButtons) {
          <button (click)="changePage(pagination.page - 1)" [disabled]="pagination.page === 1 || loading" class="nav-button">
            <app-icon [color]="selectedPageBgColor" [cssStyle]="{ marginBottom: '' }" iconName="chevron-left" size="14px"></app-icon>
          </button>
        }
        <!-- Show ellipsis with logic -->
        <!-- Dynamically create page number buttons based on pageCount -->
        @if (!isMobileView) {
          @for (p of getPages(); track p) {
            <button
              (click)="p !== '...' && changePage(+p)"
              [disabled]="p === '...' || loading"
              [ngStyle]="{
                'background-color': p === pagination.page ? selectedPageBgColor : '',
                color: p === pagination.page ? selectedPageTextColor : '',
                'border-color': p === pagination.page ? selectedPageBgColor : '#ddd',
              }"
            >
              {{ p }}
            </button>
          }
        }
        @if (showPreviousNextButtons) {
          <button (click)="changePage(pagination.page + 1)" [disabled]="pagination.page === pagination.pageCount || loading" class="nav-button">
            <app-icon [color]="selectedPageBgColor" [cssStyle]="{ marginBottom: '' }" iconName="chevron-right" size="14px"></app-icon>
          </button>
        }
        @if (showFirstLastButtons) {
          <button (click)="changePage(pagination.pageCount)" [disabled]="pagination.page === pagination.pageCount || loading" class="nav-button">
            <app-icon [color]="selectedPageBgColor" [cssStyle]="{ marginBottom: '' }" iconName="chevron-right" size="14px"></app-icon>
          </button>
        }
      </div>
    }
  </div>
}
